module.exports = __webpack_public_path__ + "files/15f16c4fc80d4f6b72e1f806227b0c5c.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-2.png
// module id = 1388
// module chunks = 59